import { Checkbox, styled } from "@mui/material";
import { Box } from "../Box";
import { Theme } from "../Theme";
import { DEFAULT_COLUMN_SIZE, MIN_COLUMN_SIZE } from "./Table";

export const StyledTable = styled(Box)(
  ({
    theme,
    props: { rowHeight },
  }: {
    theme: Theme;
    props: { rowHeight: number; columnsSize: number[] };
  }) => ({
    backgroundColor: theme.tokens.colors.gray[1],
    border: 0,
    display: "grid",
    gridTemplateRows: rowHeight,
    padding: 0,
    gridAutoFlow: "row",
    width: "100%",
    fontFamily: theme.typography.fontFamily,
    overflowX: "auto",
    position: "relative",
    ".table-row": {
      height: rowHeight,
    },
    ".table-body": {
      overflowY: "overlay",
      scrollbarGutter: "stable",
      "::-webkit-scrollbar": {
        width: "8px !important",
        height: "8px !important",
      },

      "::-webkit-scrollbar-corner": {
        backgroundColor: "transparent",
      },

      "::-webkit-scrollbar-thumb": {
        background: " #8b8b8b !important",
        borderRadius: "5px",
      },
      "::-webkit-scrollbar-track": {
        background: "#333 !important",
        borderRadius: "5px",
      },
    },
  })
);
export const BaseRow = styled("div")(
  ({
    theme,
    columnsSize,
  }: {
    theme: Theme;
    columnsSize: number[];
    isClickable?: boolean;
    isActive?: boolean;
    isChildRow?: boolean;
    isSomeExpanded?: boolean;
    stickyHeader?: boolean;
  }) => ({
    display: "grid",
    gridTemplateColumns: `${columnsSize
      .map((size) =>
        size === DEFAULT_COLUMN_SIZE
          ? `minmax(${MIN_COLUMN_SIZE}px, 1fr)`
          : `${size}px`
      )
      .join(" ")}`,
    gridAutoFlow: "column",
    padding: "0 1rem",

    borderBottom: `1px solid ${theme.tokens.colors.gray[3]}`,
    boxSizing: "border-box",
  })
);

export const StyledHeaderRow = styled(BaseRow)(
  ({
    theme,
    stickyHeader,
  }: {
    theme: Theme;
    columnsSize: number[];
    stickyHeader?: boolean;
  }) => ({
    color: theme.tokens.colors.gray[6],
    cursor: "pointer",
    position: stickyHeader ? "sticky" : "static",
    top: 0,
    zIndex: 2,
    paddingRight: "1.5rem",
    backgroundColor: theme.tokens.colors.gray[1],
    "@supports (-moz-appearance: none)": {
      paddingRight: "1rem",
    },
  })
);

export const StyledRow = styled(BaseRow)(
  ({
    theme,
    isActive,
    isClickable,
    isChildRow,
    isSomeExpanded,
  }: {
    theme: Theme;
    isClickable?: boolean;
    isActive?: boolean;
    isChildRow?: boolean;
    isSomeExpanded?: boolean;
  }) => ({
    color: theme.tokens.colors.gray[7],
    cursor: isClickable ? "pointer" : "default",

    background: isActive ? theme.tokens.colors.blue[4] : "transparent",
    "&:hover": {
      ...(!isActive && {
        background:
          theme.shapeTheme === "light"
            ? theme.tokens.colors.gray[2]
            : "#2d2d2d",
      }),
      opacity: 1,

      transition: "background 0.2s ease",
    },
    transition: "opacity 0.2s ease",
    opacity: isChildRow || isActive || !isSomeExpanded ? 1 : 0.3,
  })
);
export const StyledCell = styled("div")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: "12px",
  padding: "0.5rem",
  outline: "none",
  display: "flex",
  alignItems: "center",
}));
export const StyledCheckBox = styled(Checkbox)(() => ({
  padding: 0,
}));
export const NoDataMessage = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "1rem 0",
  color: theme.tokens.colors.gray[6],
}));
